var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{staticClass:"custom-apex-chart",attrs:{"type":_vm.type,"height":_vm.chartHeight,"options":_vm.chartData.chartOptions,"series":_vm.chartData.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }